import { cn } from "utils";
import { memo } from "react";
import { lazyHydrate } from "@ospweb/sdk-ui";
import NextImage from "../NextImage";
import { RatingScoreCardLazyLoading } from "./RatingScoreLazyLoading";
import Translations from "@translate/components/RatingScore/RatingScore";
import { I18nUtil } from "@utils/i18n";
import { useViewReportHandler } from "@/src/hooks";
const RatingScoreCardHydrated = lazyHydrate(
  () => import("./RatingScoreCard").then((mod) => mod.RatingScoreCard),
  {
    observerOptions: {
      wrapperElement: "div",
    },
    idleOptions: {
      enableIdleCallback: true,
    },
    ssr: true,
    loading: () => <RatingScoreCardLazyLoading />,
  },
);

const I18n = I18nUtil.createScoped(Translations);

interface RatingScoreProps {
  className?: string;
  rate?: string;
  id?: string;
  symbol?: string;
  type: "crypto" | "stock";
}

/**
 * RatingScore组件 - 显示评级分数和查看报告按钮
 */
const RatingScore = memo(
  ({ className, id, symbol, type, rate }: RatingScoreProps) => {
    const { handleViewReport } = useViewReportHandler({ id, symbol, type });

    return (
      <div className={cn("flex flex-col gap-4", className)}>
        <div className="md:flex flex-row headline_regular_s text-content_primary hidden">
          <span>360</span>
          <NextImage
            src="/assets/images/edgen.webp"
            alt="edge"
            className="w-[9px] h-[10px]"
          />
          <span>{I18n.t("Report")}</span>
        </div>
        <RatingScoreCardHydrated
          forceHydrate={!!rate}
          rate={rate}
          onViewReport={handleViewReport}
        />
      </div>
    );
  },
);

RatingScore.displayName = "RatingScore";

export { RatingScore };
